<script>
import CarouselComponent from "@/views/components/CarouselComponent.vue";
import {mapMutations, mapState} from "vuex";
import DepService from "@/api/services/depService";
import UtilsService from "@/api/services/utilsService";

export default {
  name: 'SubmitUsernameView',
  components: {CarouselComponent},
  computed: {
    ...mapState(['brandConfig', 'serviceId', 'msisdn', 'editUsernameRouting', 'token', 'productId']),
    isEditMode() {
      return this.$route.query.edit === 'true'
    },
  },
  data() {
    return {
      playerUsername: undefined,
      validUsername: undefined,
      usernameIncludesProfanity: null,
      errorMessage: '',
    }
  },
  methods: {
    ...mapMutations(['setUser', 'setIsLoading']),
    async startPlayingClicked(playerUsername) {
      this.setIsLoading(true)
      await this.authenticateUsername(playerUsername);
      await this.saveUsernameAndRedirect(playerUsername)
    },
    async saveUsernameAndRedirect(playerUsername) {
      if (this.validUsername) {
        const userResponse = await this.updateUser(playerUsername);

        if (userResponse === 'username-taken') {
          this.setIsLoading(false)
          this.errorMessage = 'This username is already in use. Please choose another.'

          return
        }

        this.setUser(userResponse)
        this.$router.push(this.isEditMode ? '/profile' : '/')
      } else {
        this.setIsLoading(false)
      }
    },
    async updateUser(playerUsername) {
      const response = await DepService.createUsername(this.msisdn, this.productId, playerUsername)

      if (response.data.usernameTaken) return 'username-taken'
      else return (await DepService.getUserViaProductId(this.msisdn, this.productId)).data.user;
    },
    async authenticateUsername(playerUsername) {
      this.errorMessage = ''

      if (!playerUsername || playerUsername.trim() === '') {
        this.validUsername = false
        this.errorMessage = 'Please enter a username.'

        return false
      }

      const usernameLength = playerUsername.length

      if (usernameLength < 6) {
        this.validUsername = false
        this.errorMessage = 'Username must be at least 6 characters long.'

        return false
      }

      if (usernameLength > 14) {
        this.validUsername = false
        this.errorMessage = 'Username must be no more than 14 characters long.'

        return false
      }

      const isAlphabetical = /^[a-zA-Z]+$/.test(playerUsername)

      if (!isAlphabetical) {
        this.validUsername = false
        this.errorMessage = 'Username must contain letters only (no numbers or special characters).'

        return false
      }

      await this.profanityChecker(playerUsername)

      if (this.usernameIncludesProfanity && this.usernameIncludesProfanity.containsProfanity) {
        this.validUsername = false
        this.errorMessage = 'Username contains inappropriate language. Please choose another.'

        return false
      }

      this.validUsername = true

      return true
    },
    async profanityChecker(playerUsername) {
      const profanityCheckResponse = await UtilsService.checkUsernameProfanity(playerUsername)

      this.usernameIncludesProfanity = profanityCheckResponse.data
    },
  },
}
</script>

<template>
  <div class="d-flex flex-column justify-content-start align-items-center col-12 mt-5 position-relative">
    <div class="d-flex flex-column justify-content-center align-items-start col-11">
      <img src="@/assets/onboarding/onboarding-logo.png" class="col-5"/>
    </div>
    <div class="d-flex flex-column justify-content-start align-items-end col-11">
      <img src="@/assets/onboarding/onboarding-img.png" class="col-8"/>
    </div>
    <div class="text-center fw-bold col-10 fs-5 mt-3" style="color: #000F56">
      {{
        isEditMode ? 'Update your username.' : 'Please enter a new username so we can identify you on our leaderboard.'
      }}
    </div>
    <div class="text-center col-7 fs-6 mt-3 mb-5" style="color: #000F56">
      Username must be a mixture of 6-14 alphabetical characters.
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-12 gap-3">
      <input v-model="playerUsername" @keyup.enter="startPlayingClicked(playerUsername)"
             class="col-11 msisdn-input p-4 text-center" placeholder="Enter your username"/>
      <div class="invalid-msisdn col-10 text-center" v-if="errorMessage">{{ errorMessage }}</div>
      <div class="col-11 p-4 continue-btn text-center fw-bold fs-6" @click="startPlayingClicked(playerUsername)">
        {{ isEditMode ? 'Save' : 'Continue' }}
      </div>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-11 mt-3">
      <CarouselComponent/>
    </div>
    <div class="d-flex flex-column justify-content-center text-center align-items-center col-7 mb-4 mt-4"
         style="color: #000F56">
      By entering your number you agree to our privacy policy and <span class="text-decoration-underline"
                                                                        @click="this.$router.push('/terms')">Terms & Conditions.</span>
    </div>
  </div>
</template>

<style scoped>
.msisdn-input {
  border-radius: 27px;
  border: 1px solid #CCC;
}

.continue-btn {
  border-radius: 30px;
  background: #FFCB05;
}

.invalid-msisdn {
  font-size: 12px;
  color: #ff0008;
}
</style>
